import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faCoins } from "../../utilities/fontawesomeIcons";
import { UncontrolledTooltip } from "reactstrap";
import { useAppContext } from "../../AppProvider";

export const ShipmentCostHeader = () => {
  const { dictionary } = useAppContext();
  return (
    <>
      <div className="d-flex justify-content-between">
        <div></div>
        <div
          className="row w-50 text-center"
          style={{ borderBottom: "1px solid #c7c9cd" }}
        >
          <div
            id="rating-cost-header"
            className="col-6 d-flex align-items-center justify-content-center gap-1 py-2 cursor-help"
            style={{ borderRight: "1px solid #c7c9cd" }}
          >
            <FontAwesomeIcon icon={faCoins} className="icon" />
            <UncontrolledTooltip placement="left" target="rating-cost-header">
              {dictionary.words.costs}
            </UncontrolledTooltip>
          </div>
          <div
            id="rating-time-header"
            className="col-6 d-flex align-items-center justify-content-center gap-1 pb-1 cursor-help"
          >
            <FontAwesomeIcon icon={faClock} className="icon" />
            <UncontrolledTooltip placement="left" target="rating-time-header">
              {dictionary.dates.delivery_time}
            </UncontrolledTooltip>
          </div>
        </div>
      </div>
    </>
  );
};
